import React, { type PropsWithChildren } from 'react';

import { useSpotlightTrigger } from '../helpers';

export const SpotlightTrigger = ({
	id,
	children,
}: PropsWithChildren<{
	id: string;
}>) => {
	const [isTriggered] = useSpotlightTrigger(id);

	return isTriggered ? <>{children}</> : null;
};
